/**
 * Payroll cycle hub — single entry for the close-the-period workflow.
 *
 * Tabs follow the natural flow:
 *   1. สรุปเวลา      → OwnerReconcileContent
 *   2. ตรวจก่อนปิดงวด → CloseReadinessContent
 *   3. ทำเงินเดือน    → OwnerPayrollContent
 *
 * URL hash (#reconcile|#close|#payroll) preserves deep links from
 * DailyBriefing, CloseBanner, and the rich-menu shortcuts.
 */
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { AdminLayout } from '../../components/layout/AdminLayout';
import { HubHeader, PillTabs } from '../../components/layout/HubHeader';
import { OwnerReconcileContent } from './Reconcile';
import { CloseReadinessContent } from './CloseReadiness';
import { OwnerPayrollContent } from './Payroll';

type CycleTab = 'reconcile' | 'close' | 'payroll';
const VALID_TABS: CycleTab[] = ['reconcile', 'close', 'payroll'];

export function PayrollCycle() {
  const [tab, setTab] = useState<CycleTab>(() => {
    const h = (typeof window !== 'undefined' ? window.location.hash.replace('#', '') : '') as CycleTab;
    return VALID_TABS.includes(h) ? h : 'reconcile';
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const next = `#${tab}`;
    if (window.location.hash !== next) {
      window.history.replaceState(null, '', window.location.pathname + window.location.search + next);
    }
  }, [tab]);
  // sync tab จาก #hash เมื่อ navigate ผ่าน sidebar (เมนูย่อย)
  const __loc = useLocation();
  useEffect(() => {
    const h = __loc.hash.replace('#', '') as CycleTab;
    if (VALID_TABS.includes(h)) setTab(h);
  }, [__loc.hash]);


  const CYCLE_TABS: Array<{ key: CycleTab; label: string }> = [
    { key: 'reconcile', label: '1. สรุปเวลา' },
    { key: 'close', label: '2. ตรวจก่อนปิด' },
    { key: 'payroll', label: '3. ทำเงินเดือน' },
  ];

  return (
    <AdminLayout title="รอบเงินเดือน">
      <HubHeader
        section="เงินเดือน"
        title={CYCLE_TABS.find((t) => t.key === tab)?.label.replace(/^\d+\.\s*/, '') ?? 'รอบเงินเดือน'}
      />
      <PillTabs tabs={CYCLE_TABS} active={tab} onChange={setTab} />

      {tab === 'reconcile' && <OwnerReconcileContent />}
      {tab === 'close' && <CloseReadinessContent />}
      {tab === 'payroll' && <OwnerPayrollContent />}
    </AdminLayout>
  );
}
